var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13629 10.0229H1.66553V17.3871H5.13629V10.0229Z",
    fill: "#92A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1161 6.08151C14.3267 5.08226 13.6786 4.04426 12.7311 3.72264C12.2715 3.5535 11.785 3.59136 11.3798 3.73067C10.9758 3.86953 10.5893 4.13084 10.3497 4.48962L10.349 4.4906L7.19037 9.19002H7.17345V9.21519L7.17334 9.21535L7.17345 9.21543V18.2176H7.17356L7.17334 18.2179H14.6448C15.8953 18.2179 16.5995 17.4399 17.1354 16.5909C17.7228 15.6602 18.1047 14.6685 18.3885 13.7853C18.5196 13.3773 18.6316 12.9865 18.7319 12.6363L18.7563 12.5509C18.8647 12.1732 18.9573 11.8553 19.0505 11.5953C19.3078 10.878 19.2267 10.1636 18.8189 9.62124C18.4164 9.08613 17.76 8.80343 17.0314 8.80343H13.932C13.8623 8.80343 13.8093 8.77529 13.7768 8.73856C13.7489 8.70688 13.7173 8.64754 13.732 8.53993L14.1161 6.08151ZM13.0298 9.63096C12.9957 9.60126 12.963 9.56983 12.932 9.53677L12.9232 9.63362L13.0298 9.63096Z",
    fill: "#92A1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.802246 10.2694C0.802246 9.54431 1.39002 8.95654 2.11506 8.95654H4.7407C5.46575 8.95654 6.05352 9.54431 6.05352 10.2694V17.1338C6.05352 17.7966 5.51626 18.3338 4.85352 18.3338H2.11506C1.39002 18.3338 0.802246 17.7461 0.802246 17.021V10.2694ZM2.11506 10.0818C2.01149 10.0818 1.92752 10.1658 1.92752 10.2694V17.021C1.92752 17.1245 2.01149 17.2086 2.11506 17.2086H4.92824V10.2694C4.92824 10.1658 4.84428 10.0818 4.7407 10.0818H2.11506Z",
    fill: "#92A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFill);
export default __webpack_public_path__ + "static/media/like-fill.940e58efd1afc0dfef0fe87d0ac5e591.svg";
export { ForwardRef as ReactComponent };